module.exports = __webpack_public_path__ + "img/idcard_placeholder.5fe53f43.jpg";